// Action Types

export const SHOW_TOURNAMENT_LOGGED_RUN_LOADING_SPINNER = 'SHOW_TOURNAMENT_LOGGED_RUN_LOADING_SPINNER';
export const SET_TOURNAMENT_LOGGED_RUN_LIST = 'SET_TOURNAMENT_LOGGED_RUN_LIST';
export const SET_TOURNAMENT_LOGGED_RUN_PARAMETERS = 'SET_TOURNAMENT_LOGGED_RUN_PARAMETERS';
export const TOGGLE_OPEN_LOGGED_RUN = 'TOGGLE_OPEN_LOGGED_RUN';

// Action Creator
const KeystoneLoggedRunTournamentActionCreator = {
  setLoading(loading: boolean) {
    return {
      type: SHOW_TOURNAMENT_LOGGED_RUN_LOADING_SPINNER,
      payload: {
        loading
      }
    };
  },
  setTournamentLoggedRunList(runs: any) {
    return {
      type: SET_TOURNAMENT_LOGGED_RUN_LIST,
      payload: {
        runs
      }
    };
  },
  setTournamentLoggedRunParameters(params: any) {
    return {
      type: SET_TOURNAMENT_LOGGED_RUN_PARAMETERS,
      payload: {
        params
      }
    };
  },
  toggleOpenLoggedRun(runId: number) {
    return {
      type: TOGGLE_OPEN_LOGGED_RUN,
      payload: runId
    };
  }
};

export default KeystoneLoggedRunTournamentActionCreator;
